import type { ReactNode } from 'react';
import type { FilterFieldOption } from '~/components/ui';
import { FilterRowsPanel } from '~/components/ui/FilterRowsPanel';
import { newComparisonFilterRow } from '~/pages/order-builder/lib/comparisonFilterFields';
import type { ComparisonFilterRow } from '~/pages/order-builder/lib/comparisonFilters';

type ComparisonFilterProps = {
  readonly rows: ComparisonFilterRow[];
  readonly maxHeight?: number;
  readonly fieldOptions: FilterFieldOption[];
  readonly bottomContent?: ReactNode;
  readonly onRowsChange: (rows: ComparisonFilterRow[]) => void;
};

export function ComparisonFilter({
  rows,
  maxHeight,
  fieldOptions,
  bottomContent,
  onRowsChange,
}: ComparisonFilterProps) {
  return (
    <FilterRowsPanel
      namespace="order-builder"
      keyPrefix="order_builder.filter"
      rows={rows}
      fieldOptions={fieldOptions}
      newRow={newComparisonFilterRow}
      initialValueFor={() => ''}
      valueInputFor={() => undefined}
      maxHeight={maxHeight}
      bottomContent={bottomContent}
      onRowsChange={onRowsChange}
    />
  );
}
